import React, { useState, useEffect } from 'react';
import { Icon, Tooltip, Form, Input, Message, Loading } from '@b-design/fusion';
import $i18n from '@/i18n';
import Confirm from '@/components/Confirm';
import Button, { FormSubmit, promisifyValidate } from '@/components/Button';
import { Field } from '@alifd/next';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import './index.less';

interface Props {
  info: any;
}
const Settings: React.FC<Props> = ({ info }) => {
  const field = Field.useField();
  const [loading, setLoading] = useState(false);
  const { appId } = getQueryStringArgs();
  const { init, getValue, setValue, getError } = field;
  const [btnVisable, setBtnVisable] = useState(true);
  const [preWhitelist, setPreWhitelist] = useState('');
  //重置密钥
  const handleOk = async () => {
    const res = await Requests.post('/rest/intercnn/app/rsa/update?appId=' + appId);
    if (res) {
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.invitation.spaces.message.Success',
          dm: '操作成功',
        }),
      });
    }
  };
  //下载密钥
  // const handleDown = () => {
  //   Requests.post('/rest/intercnn/app/rsa/query?appId=' + appId).then((res) => {

  //     if (res) {
  //       RequestsBlob.down('/rest/intercnn/app/rsa/public/download', { appId }).then((res) => {
  //         if (res) {
  //           // const a = document.createElement('a');
  //           // const blob = new Blob([res]);
  //           // const src = URL.createObjectURL(blob);
  //           // a.href = src;
  //           // a.download = 'fileName';
  //           // document.body.appendChild(a);
  //           // a.click();
  //           // document.body.removeChild(a);
  //         }
  //       });
  //     } else {
  //       Message.warning({
  //         title: $i18n.get({
  //           id: 'aopf.pages.miniapp.settings.tipSetKey',
  //           dm: '无密钥,请先重置密钥',
  //         }),
  //       });
  //     }
  //   });
  // };

  const handleDown = () => {
    const a = document.createElement('a');
    a.href = '/rest/intercnn/app/rsa/public/download?appId=' + appId;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  //获取白名单
  const getWhitelist = async () => {
    setLoading(true);
    const res = await Requests.get('/rest/intercnn/app/publish/version/polite/query', {
      appId,
    });
    setLoading(false);
    if (res) {
      setValue('whitelist', res.idList.join('\n'));
      setPreWhitelist(res.idList.join('\n'));
    }
  };
  //取消按钮
  const cancle = () => {
    // getWhitelist();
    setValue('whitelist', preWhitelist);
  };
  //确定设置白名单
  const submitForm = async () => {
    const [errs, val] = await promisifyValidate(field);
    if (errs) return;
    const list = val?.whitelist.split(/[(\r\n)\r\n]+/);
    const data = await Requests.post('/rest/intercnn/app/publish/version/polite/create', {
      appId,
      idList: list,
    });
    if (data) {
      getWhitelist();
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.invitation.spaces.message.Success',
          dm: '操作成功',
        }),
      });
    }
  };
  useEffect(() => {
    getWhitelist();
  }, []);
  return (
    <div className="settings-content">
      <Loading type="circle" visible={loading} style={{ width: '100%' }}>
        {info.framework == 'UniApp' && (
          <>
            <div className="keyFile">
              {$i18n.get({
                id: 'aopf.pages.miniapp.settings.HBuilder',
                dm: 'HBuilder密钥文件',
              })}
            </div>
            <Button type="primary" className="btn-down" onClick={handleDown}>
              <Icon type="download" />
              {$i18n.get({
                id: 'aopf.pages.miniapp.settings.Down',
                dm: '下载密钥文件',
              })}
            </Button>
            <Confirm
              trigger={
                <Tooltip
                  align="b"
                  v2
                  trigger={
                    <Button className="btn-renew">
                      <Icon type="renew" />
                      {$i18n.get({
                        id: 'aopf.pages.miniapp.settings.Reset',
                        dm: '重置密钥',
                      })}
                    </Button>
                  }
                  closable={false}
                >
                  <div className="popover-content">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.settings.Tooltip',
                      dm: '此密钥文件仅用于此小型应用程序。请在HBuilder的“发布版”中下载并配置它，以便新版本的迷你应用程序可以轻松同步到平台',
                    })}
                  </div>
                </Tooltip>
              }
              dialogTitle={$i18n.get({
                id: 'aopf.pages.miniapp.settings.Confirm.title',
                dm: '重置密钥',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.miniapp.settings.Confirm.content',
                dm: '确定要重置密钥吗',
              })}
              onClick={handleOk}
            />
          </>
        )}
        <Form className="form-content">
          <Form.Item
            name="whitelist"
            label={$i18n.get({
              id: 'aopf.pages.miniapp.version.info.whiteList.Whitelist',
              dm: '白名单',
            })}
            required
          >
            <Input.TextArea
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.Version.tabs.Release.user.uid',
                dm: '请输入用户uid，每行一个',
              })}
              autoHeight={{ minRows: 6, maxRows: 10 }}
              style={{ width: '680px', height: '254px' }}
              {...init('whitelist', {
                initValue: '',
                rules: [
                  // {
                  //   required: true,
                  //   message: $i18n.get({
                  //     id: 'aopf.pages.miniapp.Version.tabs.Release.user.uid',
                  //     dm: '请输入用户uid，每行一个',
                  //   }),
                  // },
                  {
                    validator: (rule, value: string) => {
                      const list = value?.split(/[(\r\n)\r\n]+/);
                      if (list.length > 50) {
                        return Promise.reject(
                          new Error(
                            $i18n.get({
                              id: 'aopf.pages.miniapp.Version.tabs.Release.lines',
                              dm: '最多50行',
                            }),
                          ),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    validator: (rule, value: string) => {
                      const list = value?.split(/[(\r\n)\r\n]+/);
                      const maxUidLength = list.filter((i) => i?.length > 32);
                      if (maxUidLength?.length > 0) {
                        return Promise.reject(
                          new Error(
                            $i18n.get({
                              id: 'aopf.pages.miniapp.Version.tabs.UID.lines',
                              dm: 'UID的最大长度为32个字符',
                            }),
                          ),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ],
              })}
            />
            <p className="errMsg">{getError('whitelist')}</p>
          </Form.Item>
          <FormSubmit
            type="primary"
            onClick={submitForm}
            validate
            style={{
              height: 32,
              fontWeight: 500,
              fontSize: '14px',
              color: '#fff',
              letterSpacing: '0.15px',
              marginTop: 90,
            }}
          >
            {$i18n.get({ id: 'aopf.pages.miniapp.settings.Save', dm: '保存' })}
          </FormSubmit>
          <Button className="btn-cancle" onClick={cancle}>
            {$i18n.get({ id: 'aopf.pages.miniapp.settings.Cancel', dm: '取消' })}
          </Button>
        </Form>
      </Loading>
    </div>
  );
};
export default Settings;
